import { useEffect, useRef } from "react";
import styles from "./LoadingSpinner.module.css";

type LoadingSpinnerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  size?: string;
  color?: string;
};

export default function LoadingSpinner({
  size = "2rem",
  color = "var(--color-primary)",
  ...rest
}: LoadingSpinnerProps) {
  return (
    <div
      className={`${styles.loader} ${rest.className ? rest.className : ""}`}
      style={{"height": size, "width": size, color, ...rest.style}}>
    </div>
  );
}
